// extracted by mini-css-extract-plugin
export var active = "_6b-7";
export var container = "_6b-0";
export var evenWidth = "_6b-4";
export var large = "_6b-5";
export var outlet = "_6b-8";
export var slide = "_6b-2";
export var small = "_6b-6";
export var tab = "_6b-3";
export var tabs = "_6b-1";